import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { LogoMark } from "@/components/Shell";

export default function PublicSite() {
  const { slug } = useParams();
  const location = useLocation();
  const [state, setState] = useState({ html: "", status: "loading" });
  const rest = location.pathname.split(`/s/${slug}`)[1] || "";
  const page = rest.replace(/^\//, "").split("/")[0] || "home";

  useEffect(() => {
    let active = true;
    setState((s) => ({ ...s, status: "loading" }));
    axios.get(`${API}/sites/${slug}`).then((meta) => {
      if (!active) return null;
      if (meta.data.public_url) {
        const target = new URL(meta.data.public_url);
        target.pathname = page === "home" ? "/" : `/${page}`;
        target.search = location.search;
        window.location.replace(target.toString());
        return null;
      }
      return axios.get(`${API}/sites/${slug}/html`, { params: { page }, responseType: "text" });
    })
      .then((r) => { if (active && r) { setState({ html: r.data, status: "ok" }); const m = r.data.match(/<title>(.*?)<\/title>/); if (m) document.title = m[1].replace(/&amp;/g, "&"); } })
      .catch(() => active && setState({ html: "", status: "missing" }));
    return () => { active = false; };
  }, [slug, page, location.search]);

  if (state.status === "missing") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white on-dark px-6" data-testid="public-site-missing">
        <div className="text-center space-y-5 max-w-sm">
          <LogoMark className="h-10 w-10 mx-auto" />
          <h1 className="font-display text-3xl">This site isn't published.</h1>
          <p className="text-sm text-white/60">It may be a draft, or the address has changed.</p>
          <Link to="/" className="btn-gold inline-flex">Build yours with LegacyStack</Link>
        </div>
      </div>
    );
  }
  return (
    <div className="h-screen w-screen bg-white" data-testid="public-site">
      {state.html ? <iframe title={`${slug} website`} srcDoc={state.html} className="h-full w-full border-0" sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-top-navigation" /> : <div className="h-full w-full flex items-center justify-center"><img src="/legacystack-mark.png" alt="" className="h-8 w-8 breathe" /></div>}
    </div>
  );
}
